const quickLinks = [
  { label: "今日热榜", href: "#hot" },
  { label: "合集汇总", href: "#collections" },
  { label: "事件时间线", href: "#timeline" },
  { label: "精华内容", href: "#featured" },
  { label: "打包下载", href: "#download" },
  { label: "常见问题", href: "#faq" },
];

const hotCollections = [
  "红毯名场面全集",
  "综艺高光时刻",
  "社会热议风向标",
  "影视剧话题簿",
  "音乐现场名场面",
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-gua py-14 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className="ri-radio-2-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                呱呱<span className="text-accent-400">爆料</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              全网热点合集整理与精华内容汇总平台。按时间线梳理事件脉络，历史记录与名场面一网打尽，支持打包下载，随时回看不遗漏。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-wechat-2-line", "ri-douban-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="关注呱呱爆料"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/10 text-background-100 transition hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="站点导航">
            <h4 className="text-sm font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-1.5 text-sm text-background-300 transition hover:text-accent-300"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门合集">
            <h4 className="text-sm font-semibold text-background-50">热门合集</h4>
            <ul className="mt-4 space-y-2.5">
              {hotCollections.map((l) => (
                <li key={l}>
                  <a
                    href="#collections"
                    className="inline-flex items-center gap-1.5 text-sm text-background-300 transition hover:text-accent-300"
                  >
                    <i className="ri-archive-2-line text-xs"></i>
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              发现遗漏或想投稿？欢迎写信告诉我们，编辑部会认真核对并及时更新。
            </p>
            <a
              href="mailto:hello@gua-baoliao.example.com"
              className="mt-3 inline-flex items-center gap-2 rounded-md bg-background-200/10 px-4 py-2 text-sm font-medium text-background-100 transition hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-mail-line"></i>
              hello@gua-baoliao.example.com
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/10">
        <div className="container-gua flex flex-col items-center justify-between gap-3 py-6 text-sm text-background-400 sm:flex-row">
          <p>© 2026 呱呱爆料 · 热点合集整理与精华内容汇总</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-accent-500"></i>
            记录热点，也记录热爱
          </p>
        </div>
      </div>
    </footer>
  );
}